import axios from 'axios';
import { toastr } from 'react-redux-toastr';

import { URL } from '../../assets/js/constants';

function fretesLoading(data) {
    return {
        type: 'FRETES_LOADING',
        payload: data
    }
}

function fretesProcessing(data) {
    return {
        type: 'FRETES_PROCESSING',
        payload: data
    }
}

export function carregarFretes(data) {
    return {
        type: 'FRETES_FETCHED',
        payload: data
    }
}

export function getFretes() {
    return dispatch => {
        dispatch(fretesLoading(true));
        axios.get(`${URL}/envios`)
            .then(resp => {
                const lista = Array.isArray(resp.data)
                    ? resp.data
                    : resp.data?.fretes || resp.data?.data || [];

                dispatch(carregarFretes(lista));
                dispatch(fretesLoading(false));
            })
            .catch(e => {
                dispatch(fretesLoading(false));
                toastr.error('Erro', e.message || 'Não foi possível carregar a lista de fretes.');
            })
    }
}

export function criarFrete(pedidoVendedorId) {
    return dispatch => {
        dispatch(fretesProcessing(true));
        axios.post(`${URL}/envios/criar-carrinho-melhor-envio?pedidoVendedorId=${pedidoVendedorId}`)
            .then(resp => {
                const message = resp?.data?.message || resp?.data?.msg || 'Frete criado com sucesso.';
                toastr.success('Sucesso', message);
                dispatch(getFretes());
                dispatch(fretesProcessing(false));
            })
            .catch(e => {
                dispatch(fretesProcessing(false));
                toastr.error('Erro', e.message || 'Não foi possível criar o frete.');
            })
    }
}

export function pagarFrete(pedidoVendedorId) {
    return dispatch => {
        dispatch(fretesProcessing(true));
        axios.post(`${URL}/envios/checkout-melhor-envio?pedidoVendedorId=${pedidoVendedorId}`)
            .then(resp => {
                const message = resp?.data?.message || resp?.data?.msg || 'Checkout realizado com sucesso.';
                toastr.success('Sucesso', message);
                dispatch(getFretes());
                dispatch(fretesProcessing(false));
            })
            .catch(e => {
                dispatch(fretesProcessing(false));
                toastr.error('Erro', e.message || 'Não foi possível realizar o checkout do frete.');
            })
    }
}

export function gerarEtiquetaFrete(pedidoVendedorId) {
    return dispatch => {
        dispatch(fretesProcessing(true));
        axios.post(`${URL}/envios/gerar-etiqueta-melhor-envio?pedidoVendedorId=${pedidoVendedorId}`)
            .then(resp => {
                const message = resp?.data?.message || resp?.data?.msg || 'Etiqueta gerada com sucesso.';
                toastr.success('Sucesso', message);
                dispatch(getFretes());
                dispatch(fretesProcessing(false));
            })
            .catch(e => {
                dispatch(fretesProcessing(false));
                toastr.error('Erro', e.message || 'Não foi possível gerar a etiqueta do frete.');
            })
    }
}

export function obterLinkEtiquetaFrete(pedidoVendedorId) {
    return dispatch => {
        dispatch(fretesProcessing(true));
        axios.get(`${URL}/envios/obter-link-melhor-envio?pedidoVendedorId=${pedidoVendedorId}`)
            .then(resp => {
                const message = resp?.data?.message || resp?.data?.msg || 'Link importado com sucesso.';
                toastr.success('Sucesso', message);
                dispatch(getFretes());
                dispatch(fretesProcessing(false));
            })
            .catch(e => {
                dispatch(fretesProcessing(false));
                toastr.error('Erro', e.message || 'Não foi possível obter o link da etiqueta.');
            })
    }
}
